import { businessGraphPayloadContainsForbiddenKeys } from "../../contracts/business-graph-export-import.js";
import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../../primitives/ids.js";
import { CLIENTOPS_WEBSITE_DELIVERY_VERTICAL_ID } from "./entities.js";
/** Private ClientOps keys that must never appear in BusinessGraph JSON trees. */
export const CLIENTOPS_PRIVATE_GRAPH_FORBIDDEN_KEYS = [
    "deliveryProject",
    "deliveryProjects",
    "workItem",
    "workItems",
    "milestone",
    "milestones",
    "assignment",
    "assignments",
    "clientContact",
    "clientContacts",
    "deliveryStatusEvent",
    "deliveryStatusEvents",
    "operationalNote",
    "operationalNotes",
    "clientOpsWebsiteDelivery",
    "clientOpsWebsiteDeliveryStore",
];
const PRIVATE_KEY_SET = new Set(CLIENTOPS_PRIVATE_GRAPH_FORBIDDEN_KEYS);
function treeContainsPrivateClientOpsKey(value) {
    if (Array.isArray(value)) {
        return value.some((item) => treeContainsPrivateClientOpsKey(item));
    }
    if (!value || typeof value !== "object") {
        return false;
    }
    for (const [key, child] of Object.entries(value)) {
        if (PRIVATE_KEY_SET.has(key)) {
            return true;
        }
        if (treeContainsPrivateClientOpsKey(child)) {
            return true;
        }
    }
    return false;
}
export function clientOpsPrivateFieldsPresentInGraphPayload(value) {
    return treeContainsPrivateClientOpsKey(value) || businessGraphPayloadContainsForbiddenKeys(value);
}
export const BusinessGraphPublicWebsiteDeliveryRefV1Schema = z
    .object({
    schemaVersion: z.literal("businessgraph.public-website-delivery-ref.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    verticalId: z.literal(CLIENTOPS_WEBSITE_DELIVERY_VERTICAL_ID),
    publicDeliveryPhase: z.enum(["INTAKE", "BUILD", "REVIEW", "LAUNCH_PREP", "LAUNCHED"]),
    publicMilestoneLabel: z.string().min(1).optional(),
    asOf: z.string().datetime(),
})
    .strict();
/** Only public delivery truth may be embedded beside an otherwise website-safe graph object. */
export function assertPublicWebsiteDeliveryRefOnly(ref) {
    const parsed = BusinessGraphPublicWebsiteDeliveryRefV1Schema.parse(ref);
    if (clientOpsPrivateFieldsPresentInGraphPayload({ publicWebsiteDeliveryRef: parsed })) {
        throw new Error("publicWebsiteDeliveryRef carried forbidden private keys");
    }
    return parsed;
}
export function rejectClientOpsStoreInBusinessGraphPayload(value) {
    if (clientOpsPrivateFieldsPresentInGraphPayload(value)) {
        throw new Error("BusinessGraph payload rejected ClientOps private website-delivery fields");
    }
}
//# sourceMappingURL=isolation.js.map